import ResourceBatch from 'js/resource_loader/ResourceBatch';

module.exports = (parameters) => {
    const ViewApi = parameters.ViewApi;
    

    let batch = new ResourceBatch();

    // batch.add_texture("path_chevrons",    "textures/path_chevrons.png");
    // batch.add_texture("red_circle",    		"textures/red_circle.png");
    // batch.add_texture("red_circle",    		"textures/red_circle.png");

    batch.add_texture("view_cube_png",    			"models/view_cube.png");
    batch.add_texture("view_cube_base_png",    	"models/view_cube_base.png");
    batch.add_dae("view_cube",    							"models/view_cube.dae");

 		batch.add_gltf("rose", 'models/test rosa.glb');
 		
    // batch.add_gltf("glb_scene", "models/ring-v2/PBR - Metallic Roughness.glb");
    // batch.add_hdr_cube("radiance", "textures/radiance/output_pmrem_");
    // batch.add_hdr_cube("skybox", "textures/skybox/output_skybox_");
    
    // batch.add_svg("svg", "Floor_1_North.svg");
    batch.load();

    let check_resource_loading = ()=>{
      if(batch.loading_finished)
      {
        if(batch.has_errors)
        {
          batch.print_errors();
        }
        else
        {
          ViewApi.resource_loading_completed();
          ViewApi.start();
        }
      }
      else
      {
        setTimeout(check_resource_loading, 200);
      }
    }
    check_resource_loading();



    // let resources_to_load = 1;
    // const ready_callback = () => {
    //   if (! --resources_to_load) {
    //     ViewApi.resource_loading_completed();
    //     ViewApi.start();
    //   }
    // }

    // let loadingManager = new THREE.LoadingManager();
    // let loader = new THREE.ColladaLoader( loadingManager );


    // WebFont.load({
    //   custom: {
    //     families: ['calibri']
    //   },
    //   active:()=>{
    //     ready_callback();
    //   }
    // });




};
